exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "footer {\n  padding: 25px 0;\n  text-align: center; }\n  @media (max-width: 1024px) {\n    footer {\n      padding-bottom: 100px; } }\n  @media (max-width: 768px) {\n    footer {\n      padding-bottom: 150px; } }\n  footer span.copyright {\n    font-size: 90%;\n    line-height: 40px;\n    text-transform: none;\n    font-family: 'Montserrat', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n    text-transform: uppercase; }\n  footer ul.quicklinks {\n    font-size: 90%;\n    line-height: 40px;\n    margin-bottom: 0;\n    text-transform: none;\n    font-family: 'Montserrat', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n    text-transform: uppercase; }\n  footer .fixed-banner {\n    position: fixed;\n    right: 0;\n    bottom: 0;\n    z-index: 10000; }\n    footer .fixed-banner img {\n      width: 100%;\n      max-width: 300px;\n      height: auto; }\n      @media (max-width: 1024px) {\n        footer .fixed-banner img {\n          max-width: 200px; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Projects/dod/companyintroduction/src/app/footer/footer.component.scss
// module id = ../../../../../src/app/footer/footer.component.scss
// module chunks = main